module.exports = "/images/miplogo-300x300.png?4918344217e1baad53c227b037dc469e";